import { useRouter } from "next/router";

export interface RedirectProps {
  defaultPath: string;
}

export const useRedirect = ({ defaultPath }: RedirectProps) => {
  const router = useRouter();

  const getNextPath = () => {
    return decodeURIComponent(router.query.next?.toString() ?? "");
  };

  const passQueryParams = (window: Window | undefined) => {
    if (window) {
      return window.location.search;
    }
    return "";
  };

  const pushToNextPath = (path?: string) => {
    const nextPath = getNextPath();
    router.push(!!nextPath ? nextPath : path ?? defaultPath);
  };
  const redirectToNextPath = (path?: string) => {
    const nextPath = getNextPath();
    router.replace(!!nextPath ? nextPath : path ?? defaultPath);
  };
  const createNextPathUrl = (
    path: string,
    nextPath?: string,
    queryParams?: string
  ) => {
    const completeNextPath = nextPath || getNextPath();
    const query = completeNextPath
      ? `next=${encodeURIComponent(completeNextPath)}${
          queryParams ? "&" + queryParams : ""
        }`
      : queryParams || "";
    const url = `${path}?${query}`;
    return url;
  };

  const pushWithNextPath = (path: string) => {
    const url = createNextPathUrl(path, window?.location.pathname);
    router.push(url);
  };

  return {
    getNextPath,
    pushToNextPath,
    pushWithNextPath,
    createNextPathUrl,
    passQueryParams,
    redirectToNextPath,
  };
};
